
if (!customElements.get('qv-invoice')) {
  class QvInvoice extends HTMLElement {
    static draft = null;
    connectedCallback() {
      this.toggle = this.querySelector('[data-invoice-toggle]');
      this.fields = this.querySelector('.qv-invoice__fields');
      this.type = this.querySelector('[data-invoice-type]');
      this.request = this.querySelector('[data-invoice-request]');
      if (QvInvoice.draft) {
        this.toggle.checked = QvInvoice.draft.requested;
        for (const field of this.querySelectorAll('[name]')) {
          if (Object.hasOwn(QvInvoice.draft.values, field.name)) field.value = QvInvoice.draft.values[field.name];
        }
      }
      this.onInput = (event) => {
        if (event.target === this.toggle && this.toggle.checked) {
          const country = this.querySelector('[data-invoice-field="country"]');
          if (!country.value) country.value = 'Italia';
        }
        this.update(); this.remember();
      };
      this.addEventListener('input', this.onInput);
      this.addEventListener('change', this.onInput);
      this.onCheckout = (event) => {
        const button = event.target.closest('[name="checkout"]');
        if (!button || button.form?.id !== 'cart-form') return;
        this.update();
        this.remember();
      };
      document.addEventListener('click', this.onCheckout, true);
      this.update();
      this.remember();
      this.observer = new MutationObserver(() => {
        if (!QvInvoice.draft) return;
        const previousType = QvInvoice.draft.values[this.type.name];
        if (this.type.value !== previousType) {
          this.type.value = previousType;
          this.update();
        }
      });
      this.observer.observe(this.type, { attributes: true, childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('change', this.onInput);
      document.removeEventListener('click', this.onCheckout, true);
    }
    remember() {
      QvInvoice.draft = { requested: this.toggle.checked, values: {} };
      for (const field of this.querySelectorAll('[name]')) QvInvoice.draft.values[field.name] = field.value;
    }
    update() {
      const enabled = this.toggle.checked;
      const business = this.type.value === 'Azienda';
      const italy = /^(italia|italy|it)$/i.test(this.querySelector('[data-invoice-field="country"]').value.trim());
      this.fields.hidden = !enabled;
      this.request.value = enabled ? 'Si' : 'No';
      this.toggle.setAttribute('aria-expanded', String(enabled));
      for (const field of this.querySelectorAll('[data-invoice-field]')) {
        const key = field.dataset.invoiceField;
        const applicable = key !== 'vat' || business;
        const required = enabled && applicable && (field.hasAttribute('data-required') || key === 'vat' || (key === 'cf' && !business && italy));
        field.required = required;
        const marker = field.closest('label').querySelector('[data-invoice-required]');
        if (marker) marker.hidden = !required;
        field.setCustomValidity('');
        field.closest('label').hidden = !applicable;
        if (!enabled || !applicable) field.value = '';
      }
      const vat = this.querySelector('[data-invoice-field="vat"]');
      const cf = this.querySelector('[data-invoice-field="cf"]');
      const sdi = this.querySelector('[data-invoice-field="sdi"]');
      for (const field of [vat, cf, sdi]) field.value = field.value.replace(/\s/g, '').toUpperCase();
      vat.maxLength = italy ? 11 : 30;
      if (enabled && italy && vat.value && !/^\d{11}$/.test(vat.value)) vat.setCustomValidity(this.dataset.vatError);
      if (enabled && italy && cf.value && !/^(?:[A-Z0-9]{16}|\d{11})$/.test(cf.value)) cf.setCustomValidity(this.dataset.cfError);
      if (enabled && sdi.value && !/^[A-Z0-9]{7}$/.test(sdi.value)) sdi.setCustomValidity(this.dataset.sdiError);
      const accelerated = this.closest('.cart-drawer__summary, .cart-summary')?.querySelector('.additional-checkout-buttons') || document.querySelector('.cart__ctas .additional-checkout-buttons');
      if (accelerated) accelerated.hidden = enabled;
    }
  }
  customElements.define('qv-invoice', QvInvoice);
}
